import { ThemeProvider } from './theme/theme.provider.tsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppBarLayout } from './layouts/app-bar.layout.tsx';
import { DialogesLayout } from './layouts/dialog.layout.tsx';
import { Paths } from './constants/paths.ts';
import { HomePage } from './pages/home.page.tsx';
import { GraphqlProvider } from './graphql/utils/graphql-provider.tsx';
import { LoginPage } from './pages/auth/login.page.tsx';
import { SnackbarProvider } from './contexts/snackbar.context.tsx';
import { AuthProvider } from './contexts/auth.context.tsx';
import { AuthGuard } from './guards/auth.guard.tsx';
import { RegisterPage } from './pages/auth/register.page.tsx';
import { CreatePasskeyPage } from './pages/auth/create-passkey.page.tsx';
import { LogoutPage } from './pages/auth/logout.page.tsx';
import { TokenRefresher } from './utils/token-refresher.tsx';
import { BottomNavLayout } from './layouts/bottom-nav.layout.tsx';
import { PermissionPage } from './pages/utils/permission.page.tsx';
import { ActivityPlanningPage } from './pages/activity-planning/activity-planning.page.tsx';
import { ActivityEditingPage } from './pages/activity-editing/activity-editing.page.tsx';
import { ResourcePage } from './pages/resource.page.tsx';
import { WelcomePage } from './pages/registration/welcome.page.tsx';
import { TutorialPage } from './pages/registration/tutorial.page.tsx';
import { UserProfilePage } from './pages/registration/user-profile.page.tsx';
import { NotificationPage } from './pages/registration/notification.page.tsx';
import { UserInfoPage } from './pages/registration/user-info.page.tsx';
import { StudyQuestionsPage } from './pages/registration/study-questions.page.tsx';
import { NotificationProvider } from './contexts/notification.context.tsx';
import { MessageListPage } from './pages/messages/message-list.page.tsx';
import { AppBarBackLayout } from './layouts/app-bar-back.layout.tsx';
import { MessagePage } from './pages/messages/message.page.tsx';
import { DailyLogPage } from './pages/daily-log/daily-log.page.tsx';
import { WeeklyLogPage } from './pages/weekly-log.page.tsx';
import { LetGetStartedPage } from './pages/registration/let-get-started.page.tsx';
import { DialogProvider } from './contexts/dialog.context.tsx';
import { MotivationQuestionsPage } from './pages/registration/motivation-questions.page.tsx';
import { MobileProvider } from './contexts/mobile.context.tsx';
import { ReplanActivitesPage } from './pages/activity-planning/replan-activites.tsx';
import { TrackingPage } from './pages/registration/tracking.page.tsx';
import { AchievementPage } from './pages/achievement/achievement.page.tsx';
import { PageViewTracker } from './utils/page-view-tracker.tsx';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <DialogProvider>
          <SnackbarProvider>
            <AuthProvider>
              <GraphqlProvider>
                <MobileProvider>
                  <NotificationProvider>
                    <TokenRefresher />
                    <PageViewTracker />
                    <Routes>
                      <Route element={<DialogesLayout />}>
                        <Route element={<AuthGuard />}>
                          <Route element={<BottomNavLayout />}>
                            <Route path={Paths.HOME} element={<HomePage />} />
                            <Route path={Paths.MESSAGES} element={<MessageListPage />} />
                            <Route path={Paths.ACHIEVEMENTS} element={<AchievementPage />} />
                          </Route>
                          <Route element={<AppBarLayout />}>
                            <Route path={Paths.CREATE_PASSKEY} element={<CreatePasskeyPage />} />
                            <Route path={Paths.LOGOUT} element={<LogoutPage />} />
                            <Route path={Paths.ACTIVITY_PLANNING} element={<ActivityPlanningPage />} />
                            <Route path={Paths.REPLAN_ACTIVITES} element={<ReplanActivitesPage />} />
                          </Route>
                          <Route element={<AppBarBackLayout />}>
                            <Route path={Paths.MESSAGE} element={<MessagePage />} />
                            <Route path={Paths.DAILY_LOG} element={<DailyLogPage />} />
                            <Route path={Paths.ENABLE_NOTIFICATIONS} element={<NotificationPage />} />
                            <Route path={Paths.ENABLE_TRACKING} element={<TrackingPage />} />
                            <Route path={Paths.STUDY_QUESTIONS} element={<StudyQuestionsPage />} />
                            <Route path={Paths.MOTIVATION_QUESTIONS} element={<MotivationQuestionsPage />} />
                            <Route path={Paths.WEEKLY_LOG} element={<WeeklyLogPage />} />
                            <Route path={Paths.USER_INFO} element={<UserInfoPage />} />
                            <Route path={Paths.RESOURCES} element={<ResourcePage />} />
                            <Route path={Paths.ACTIVITY_EDITING} element={<ActivityEditingPage />} />
                          </Route>
                          <Route path={Paths.WELCOME} element={<WelcomePage />} />
                          <Route path={Paths.LET_GET_STARTED} element={<LetGetStartedPage />} />
                          <Route path={Paths.USER_PROFILE} element={<UserProfilePage />} />
                        </Route>
                        <Route element={<AppBarLayout />}>
                          <Route path={Paths.LOGIN} element={<LoginPage />} />
                          <Route path={Paths.REGISTER} element={<RegisterPage />} />
                          <Route path={Paths.PERMISSION_REQUIRED} element={<PermissionPage />} />
                          <Route path={Paths.TUTORIAL} element={<TutorialPage />} />
                        </Route>
                      </Route>
                    </Routes>
                  </NotificationProvider>
                </MobileProvider>
              </GraphqlProvider>
            </AuthProvider>
          </SnackbarProvider>
        </DialogProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
